import AbstractView from "../../../../../shared/src/ranj/equalture/view/AbstractView";

export default class HudView extends AbstractView {
    constructor(target, languagePack) {
        super(target);
        this._languagePack = languagePack;

        this._levelTextfield = this._target.levelTextfield;

        this._target.levelLabelTextfield.text = this.getText("hud.level.label");
        this._target.practiceIndicator.textfield.text = this.getText("hud.practiceIndicator");
        this.showPracticeIndicator(false, true);
    }

    showPracticeIndicator(bool, instant = false) {
        var targetAlpha = bool ? 1 : 0;

        if (instant) {
            this._target.practiceIndicator.alpha = targetAlpha;
            return;
        } else {
            createjs.Tween.get(this._target.practiceIndicator).to({ alpha: targetAlpha }, 500, createjs.Ease.quadOut);
        }
    }

    setLevel(idx, total) {
        let str = this.getText("hud.level", { CURRENT: idx, TOTAL: total });
        this._levelTextfield.text = str;
    }
}